/**
 * ノート操作APIに付けると、応答から全ノート一覧が省かれる。
 *
 * この画面は一覧を必要とするときだけ一覧APIを呼ぶため、ノートを変えるたびに
 * サーバへ全件を作らせない。サーバは指定が無いリクエストにだけ従来どおり一覧を返すので、
 * 更新していない旧クライアントには影響しない。
 */
export const omitFileList = { files: 'omit' } as const;
